import { Button, useDisclosure } from "@chakra-ui/react";
import { RepeatIcon } from "@chakra-ui/icons";
import ReprocessarCobrancasModal from "../components/ReprocessarCobrancasModal";

type Props = {
  // Chamado depois que o backend aceitou o reprocessamento — a tela dona
  // invalida as queries dela (o job roda em background).
  onReprocessado?: () => void;
};

// Botão "Reprocessar" do cabeçalho das telas de Vínculos (Ativos e Encerrados).
// O reprocessamento é global (todas as CCBs, por período) — não pertence a uma
// CCB nem aos filtros: fica ao lado do título da página, na mesma linha do
// "Como utilizar". Como o cabeçalho é um gradiente primary→secondary, o sólido
// primary sumiria no fundo: fundo branco com o texto na cor primária.
export default function ReprocessarCobrancasButton({ onReprocessado }: Props) {
  const modal = useDisclosure();

  return (
    <>
      <Button
        leftIcon={<RepeatIcon />}
        size="sm"
        bg="white"
        color="primary"
        _hover={{ bg: "whiteAlpha.900" }}
        _active={{ bg: "whiteAlpha.800" }}
        fontFamily="Lexend Deca"
        onClick={modal.onOpen}
      >
        Reprocessar
      </Button>
      <ReprocessarCobrancasModal isOpen={modal.isOpen} onClose={modal.onClose} onSuccess={onReprocessado} />
    </>
  );
}
